import styled from "@emotion/styled";

const Styles = styled.div`
  text-align: left;
`;
export default Styles;
